import { COMMERCE_CSS as CARDS_CSS } from "./cards";
import { COMPARE_CSS } from "./compare";

/**
 * Tot CSS-ul stratului de commerce, într-un singur șir: `sdk.ts` îl injectează
 * o dată (`widget.addStyle`), iar despărțirea pe fișiere e a codului, nu a
 * livrării - un al doilea `<style>` ar fi doar un al doilea loc de uitat.
 */
export const COMMERCE_CSS = `${CARDS_CSS}\n${COMPARE_CSS}`;
export { openComparisonModal, renderComparison, type ComparisonModal } from "./compare";
export { CommerceRuntime, updateCartBadges, CART_COUNT_SELECTORS } from "./runtime";
export { createShopifyAdapter } from "./shopify";
export { createWooCommerceAdapter } from "./woocommerce";
export { createCommerceAdapter } from "./adapter";
export { readCommerceConfig } from "./types";
export { commerceText, type CommerceCopy } from "./text";
export { syncThemeCart, cartSectionIds, CART_LINES_UPDATE_EVENT, CART_SECTION_SELECTOR } from "./themeSync";
export type { CartMutationAction, ThemeSyncInput } from "./themeSync";
export type { CommerceAdapter, CommerceConfig, CommercePlatform, AdapterResult, MutationContext } from "./types";
export type { CommerceHost } from "./runtime";
